import { render, staticRenderFns } from "./taxinfo-modal.vue?vue&type=template&id=43931834&scoped=true&"
import script from "./taxinfo-modal.vue?vue&type=script&lang=tsx&"
export * from "./taxinfo-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./taxinfo-modal.vue?vue&type=style&index=0&id=43931834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43931834",
  null
  
)

export default component.exports